import React from "react";
import ibtehaz from "../../static/ibtehaz-new.jpg";
import themeLarge from "../ThemeLarge";

class Intro extends React.Component {
  constructor(props) {
    super(props);
    const buttonOptions = [
      {
        text: "Wanna Chat? I'm on LinkedIn",
        url: "https://www.linkedin.com/in/ibtehaz/",
        target: "_blank",
      },
      {
        text: "Explore my latest thoughts and writings - My Blogs!",
        url: "https://ibtehaz.xyz/blogs",
        target: "_self",
      },
      {
        text: "Built with caffeine and dreams — My Projects!",
        url: "https://ibtehaz.xyz/projects",
        target: "_self",
      },
    ];

    this.greetings = [
      { lang: "en", text: "Hi! I am" },
      { lang: "bn", text: "হ্যালো! আমি" }, // Bengali
      { lang: "ja", text: "わたしわ は" }, // Japanese
      { lang: "ru", text: "Здравствуйте! я" }, // Russian
      { lang: "fi", text: "Moi! Olen" }, // Finnish
    ];

    this.state = {
      hovering: false,
      imageSrc: ibtehaz,
      buttonChoice:
        buttonOptions[Math.floor(Math.random() * buttonOptions.length)],
      currentGreetingIndex: 0,
      fade: true,
    };
  }

  componentDidMount() {
    this.greetingInterval = setInterval(() => {
      this.setState({ fade: false });

      setTimeout(() => {
        this.setState((prevState) => ({
          currentGreetingIndex:
            (prevState.currentGreetingIndex + 1) % this.greetings.length,
          fade: true,
        }));
      }, 1000); // fade-out duration before switching
    }, 4000); // switch every 4 seconds
  }

  componentWillUnmount() {
    clearInterval(this.greetingInterval);
  }

  handleMouseEnter = () => {
    this.setState({
      hovering: true,
      imageSrc: ibtehaz,
    });
  };

  handleMouseLeave = () => {
    this.setState({
      hovering: false,
      imageSrc: ibtehaz,
    });
  };

  render() {
    const { hovering, imageSrc, currentGreetingIndex, fade } = this.state;
    const currentGreeting = this.greetings[currentGreetingIndex].text;

    return (
      <>
        {/* In-component CSS styling for hover effect */}
        <style>{`
          .fade-text {
            transition: opacity 0.5s ease-in-out;
            opacity: ${fade ? 1 : 0};
            display: inline-block;
          }

          .linked-hover {
            position: relative;
            overflow: hidden;
            transition: transform 0.4s ease, color 0.4s ease, box-shadow 0.4s ease;
            z-index: 0;
          }

          .linked-hover::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 0%;
            background-color: ${themeLarge.colors.text};
            z-index: -1;
            transition: width 2s ease;
          }

          .linked-hover:hover::before {
            width: 100%;
          }

        .linked-hover:hover {
          color: ${themeLarge.colors.bg} !important;
          // transform: translateY(-4px) scale(1.03); /* slightly larger + smooth */
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
        }
          
          #homePage {
            transition: background-color 0.8s ease;
          }
          
          .profile-img {
            transition: opacity 0.8s ease;
          }
        `}</style>
        <div
          id="homePage"
          className="row"
          style={{
            background: hovering
              ? themeLarge.colors.gradient
              : themeLarge.colors.primary,
            paddingBottom: "50px",
            transition: "background 2s ease", // ONLY animate color
          }}
        >
          <div
            className="col-md-5"
            style={{
              paddingTop: "50px",
              paddingLeft: "100px",
            }}
          >
            {/* left */}
            <h1
              style={{
                fontSize: themeLarge.fontSize.display,
                color: hovering ? themeLarge.colors.text : themeLarge.colors.bg,
                fontFamily: "Noto Sans",
                transition: "color 2s ease", // ONLY animate color
              }}
            >
              <span className="fade-text">{currentGreeting}</span> <br />{" "}
              Ibtehaz
            </h1>
            <p
              style={{
                fontSize: themeLarge.fontSize.h4, // Fixed font size
                color: hovering ? themeLarge.colors.text : themeLarge.colors.bg,
                fontFamily: "Kumbh Sans",
                marginTop: "25px",
                transition: "color 2s ease", // ONLY animate color
                transform: hovering ? "scale(1.02)" : "scale(1)", // slight grow on hover
              }}
            >
              {hovering && (
                <>
                  Driven by wonder, fueled by creativity. <br />
                  Forever exploring, forever evolving.
                </>
              )}
              {!hovering && (
                <>
                  I design and build thoughtful digital experiences. <br />
                  Curious mind, creative heart, always learning
                </>
              )}
            </p>

            <button
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}
              onClick={() =>
                window.open(
                  this.state.buttonChoice.url,
                  this.state.buttonChoice.target
                )
              }
              style={{
                boxShadow: themeLarge.shadows.standard,
                color: themeLarge.colors.text,
                fontSize: themeLarge.fontSize.h4,
                borderRadius: "15px",
                marginTop: "10px",
                padding: "10px",
                background: themeLarge.colors.secondary,
                width: "500px",
                cursor: "pointer",
              }}
              className="linked-hover"
            >
              {this.state.buttonChoice.text}
            </button>
          </div>

          <div className="col-md-2"></div>

          <div
            className="col-md-5"
            style={{
              padding: "50px",
            }}
          >
            {/* right */}
            <img
              src={imageSrc}
              alt="This is Ibtehaz"
              className="profile-img"
              style={{
                width: "330px",
                height: "300px",
                borderRadius: "15px",
                marginLeft: "50px",
                opacity: 1,
                transition: "all 2s ease-in-out",
                transform: hovering ? "scale(1.13)" : "scale(1)",
                boxShadow: hovering
                  ? themeLarge.shadows.large
                  : themeLarge.shadows.little,
              }}
            />
          </div>
        </div>
      </>
    );
  }
}

export default Intro;
